import { useItemFilterValues } from '@/features/items';

import { TasksList } from './tasks-list';

export const RoomTasksList = () => {
  const { locationIdOrAdjacentLocationIdEq } = useItemFilterValues();
  return <TasksList filters={{ locationId: locationIdOrAdjacentLocationIdEq }} showEditButton />;
};
